// โหลด LINE LIFF SDK (~200 KB ก่อนบีบ) เฉพาะตอนต้องใช้จริง
// เดิม import ตรง ๆ = ทุกหน้าสมาชิกโหลด+parse SDK ทั้งก้อน ทั้งที่หน้าส่วนใหญ่ข้าม LIFF ไปแล้ว
// (meta member-authed) — มือถือใน LINE ช้าลงเปล่า ๆ; import() ทำให้ Vite แยกเป็น chunk ของมันเอง
let liffPromise = null

export default function loadLiff() {
  liffPromise ??= import("@line/liff").then((m) => m.default)
  return liffPromise
}
